import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-table-container',
  templateUrl: './table-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableContainerComponent {
  table: any;
}

export const tableContainerResolver = (registry, data) => {
  return {
    table: data.table[0],
  };
};
